import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/skihh497_Copia%20de%20HISTORIAS%20ORG%20RAM%20%28Tu%20historia%29%20%281%29.png";

export const Header = ({ onCotizarClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Servicios', href: '#servicios' },
    { label: 'Nosotros', href: '#nosotros' },
    { label: 'Contacto', href: '#contacto' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-background/95 backdrop-blur-md shadow-lg py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#inicio" className="flex items-center gap-3 group" onClick={(e) => { e.preventDefault(); scrollToSection('#inicio'); }}>
            <div className={`p-1 rounded-lg transition-all duration-300 ${isScrolled ? 'bg-primary' : ''}`}>
              <img 
                src={LOGO_URL} 
                alt="Organizacion Ram" 
                className={`h-10 md:h-12 w-auto transition-all duration-300 group-hover:scale-105 ${isScrolled ? 'brightness-0 invert' : ''}`}
              />
            </div>
            <span className={`font-bold text-sm md:text-base tracking-tight transition-colors duration-300 whitespace-nowrap ${
              isScrolled ? 'text-foreground' : 'text-white'
            }`}>
              ORGANIZACIÓN RAM
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
                className={`font-medium text-sm transition-colors duration-300 link-underline ${
                  isScrolled ? 'text-foreground hover:text-primary' : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Button 
              onClick={onCotizarClick}
              className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
            >
              <i className="fas fa-file-invoice mr-2"></i>
              Cotizar
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button 
                variant="ghost" 
                size="icon"
                className={`${isScrolled ? 'text-foreground' : 'text-white'}`}
              >
                <i className="fas fa-bars text-xl"></i>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-background">
              <div className="flex flex-col gap-6 mt-8">
                <div className="flex items-center gap-3 mb-4">
                  <img src={LOGO_URL} alt="Organizacion Ram" className="h-16 w-auto" />
                  <span className="font-bold text-lg">ORGANIZACIÓN RAM</span>
                </div>
                
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
                    className="text-foreground font-medium text-lg py-2 border-b border-border hover:text-primary transition-colors"
                  >
                    {link.label}
                  </a>
                ))}
                
                <Button 
                  onClick={() => { onCotizarClick(); setIsMobileMenuOpen(false); }}
                  className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold w-full mt-4 rounded-full"
                >
                  <i className="fas fa-file-invoice mr-2"></i>
                  Cotizar
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
